import { createFileRoute, notFound } from "@tanstack/react-router";
import ErrorComponent from "@/components/blocks/error-component";
import {
	BlogNotFoundError,
	getBlogBySlug,
	getRelatedBlogs,
	isValidBlogSlug,
} from "@/lib/utils/blog.utils";
import { generateSeo } from "@/lib/utils/seo";

export const Route = createFileRoute("/blog/$slug")({
	loader: async ({ params }) => {
		if (!isValidBlogSlug(params.slug)) {
			throw notFound();
		}

		try {
			const [blog, relatedBlogs] = await Promise.all([
				getBlogBySlug(params.slug),
				getRelatedBlogs(params.slug, 3),
			]);
			return { blog, relatedBlogs };
		} catch (error) {
			if (error instanceof BlogNotFoundError) {
				throw notFound();
			}
			throw error;
		}
	},
	errorComponent: ErrorComponent,
	head: ({ loaderData }) => {
		if (!loaderData?.blog) return {};
		return generateSeo({
			title: `${loaderData.blog.title} | CraftLayer Blog`,
			description: loaderData.blog.description,
			image: loaderData.blog.image,
			url: `/blog/${loaderData.blog.slug}`,
			keywords: loaderData.blog.keywords,
		});
	},
});
